import Admin from '@components/admin/Admin'
import Page from '@components/Page/Page'
import { TableUrlParams, useTableUrlSync } from '@hooks/useTableUrlSync'
import { Admin as AdminModel } from '@models/Admin'
import { getAdmins, selectAdmins, setAdminQuery } from '@store/AdminReducer'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { SBTable, TableParams } from '@supplement-bacon/sb-table-filters'
import { SBRM, SBRMAction, useSBRM } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { Permission } from '@utils/permissions'
import type { TableColumnsType } from 'antd'
import { useEffect, useState } from 'react'

const AdminsPage = () => {
  const { isOpen } = useSBRM()
  const dispatch = useAppDispatch()
  const admins = useAppSelector(selectAdmins())
  const { query, isLoading } = useAppSelector((state) => state.admin)
  const [isFirstRender, setIsFirstRender] = useState<boolean>(true)

  const columns: TableColumnsType<AdminModel> = [
    {
      title: 'Full name',
      render: (record: AdminModel) => <Admin.Avatar model={record} />,
    },
    {
      title: 'Email',
      dataIndex: 'email',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
    },
    {
      key: 'Role',
      title: 'Role',
      render: (record: AdminModel) => <Admin.SelectRole adminId={record.id} />,
    },
    {
      key: 'actions',
      title: 'Actions',
      align: 'right',
      render: (record: AdminModel) => (
        <SBRM.Actions
          entityId={record.id}
          entity={Entity.admin}
          actions={[SBRMAction.Update, SBRMAction.Delete]}
        />
      ),
    },
  ]

  const fetchAdmins = (params: TableUrlParams) => {
    const newQuery: TableParams = {
      ...query,
      pagination: {
        ...query.pagination,
        current: params.page,
        pageSize: params.pageSize,
      },
    }

    dispatch(setAdminQuery(newQuery))
    dispatch(getAdmins(newQuery))
  }

  const { handleTableChange, params } = useTableUrlSync<AdminModel>({
    onParamsChange: fetchAdmins,
  })

  useEffect(() => {
    if (!isFirstRender && isOpen) return

    setIsFirstRender(false)
    fetchAdmins(params)
  }, [isOpen])

  return (
    <Page
      permissions={Permission.listAdmin}
      pageTitle={{
        title: 'Administrators',
        level: 4,
        toolbar: (
          <SBRM.Actions entity={Entity.admin} actions={[SBRMAction.Create]} />
        ),
      }}
    >
      <SBTable
        columns={columns}
        dataSource={admins}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={query.pagination}
        scroll={{ x: 'max-content' }}
      />
    </Page>
  )
}

export default AdminsPage
